import axios from 'axios';

export default {
    getCode(context, data) {
        var self = this;

        var options = {
            url: window.apiUrl + '/versapay/authorize',
            headers: {'Authorization': 'Bearer ' + localStorage.token},
            data:data,
            method: 'post'
        };
        return axios.request(options).then(function(response) {
            return response;        
        });
    },

};



// WEBPACK FOOTER //
// ./src/services/oauth/index.js